import { createAction } from "redux-actions";
import { createRequestActionTypes } from "../../common/saga/createRequestSaga";

export const [
  SEND_FIND_PASSWORD_CODE,
  SEND_FIND_PASSWORD_CODE_SUCCESS,
  SEND_FIND_PASSWORD_CODE_FAILURE,
  SEND_FIND_PASSWORD_CODE_INIT
] = createRequestActionTypes("findPassword/SEND_CODE");

export const [
  RESET_PASSWORD_BY_CODE,
  RESET_PASSWORD_BY_CODE_SUCCESS,
  RESET_PASSWORD_BY_CODE_FAILURE,
  RESET_PASSWORD_BY_CODE_INIT
] = createRequestActionTypes("findPassword/RESET");

export const sendFindPasswordCodeAction = createAction(
  SEND_FIND_PASSWORD_CODE,
  ({ mbrId }) => ({ mbrId })
);

export const resetPasswordByCodeAction = createAction(
  RESET_PASSWORD_BY_CODE,
  ({ mbrId, code, password }) => ({ mbrId, code, password })
);

export const findPasswordInit = createAction(SEND_FIND_PASSWORD_CODE_INIT);
export const resetPasswordInit = createAction(RESET_PASSWORD_BY_CODE_INIT);
